import AOS from "aos";

import ready from "./ready";

ready(() => {
  AOS.init();
});
